/* eslint-disable react/prop-types */
import UpgradeFailureStep from './UpgradeFailureStep';
import UpgradeIntroStep from './UpgradeIntroStep';
import UpgradeStep from './UpgradeStep';
import UpgradeSuccessStep from './UpgradeSuccessStep';
import { stepsEnum } from '../utils';

const UpgradeStepStrategy = ({
  upgradeStep,
  closeDialog,
  isTwoStepDialog,
  upgradeIsTrialer,
  upgradeIsSuspended,
  ...otherProps
}) => {
  const sharedProps = {
    closeDialog,
    ...otherProps,
  };

  const shouldCloseDialog = upgradeStep === stepsEnum.CLOSE;
  const shouldShowSuccess = upgradeStep === stepsEnum.SUCCESS;
  const shouldShowFailure = upgradeStep === stepsEnum.FAILURE;
  const shouldShowUpgradeStep = upgradeStep === stepsEnum.UPGRADE;
  const isOneStepDialog = !isTwoStepDialog;
  const isTrialerOrSuspended = upgradeIsTrialer || upgradeIsSuspended;

  if (shouldCloseDialog) {
    closeDialog();

    return <UpgradeIntroStep {...sharedProps} />;
  }

  if (shouldShowSuccess) {
    return <UpgradeSuccessStep {...sharedProps} />;
  }

  if (shouldShowFailure) {
    return <UpgradeFailureStep {...sharedProps} />;
  }

  if (isOneStepDialog) {
    return <UpgradeStep {...sharedProps} />;
  }

  // below are two step dialog views
  if (isTrialerOrSuspended) {
    return <UpgradeIntroStep {...sharedProps} />;
  }

  if (shouldShowUpgradeStep) {
    return <UpgradeStep {...sharedProps} />;
  }

  return <UpgradeIntroStep {...sharedProps} />;
};

export default UpgradeStepStrategy;
